<template>
  <div id="ecommerce-checkout">
    <header class="checkout-top">
      <img :src="`/assets/images/logo/logo_basket_${appFilename}.svg`" alt="" height="40px" class="checkout-top__logo" />
      <p class="checkout-top__tagline">Checkout seguro</p>
    </header>

    <OrderDetails :orderDetails="orderDetails" />
    <form-wizard
      ref="checkoutWizard"
      color="#5c3498"
      :startIndex="0"
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
      @on-change="onCheckoutStepChange"
      v-if="!orderId || !orderNumber"
      class="checkout-wizard"
    >
      <tab-content title="Conta" icon="feather icon-user" class="mb-5">
        <vx-card class="checkout-surface">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex flex-col md:flex-row p-4 md:p-0" v-if="!basket.email">
                <div class="vx-col  md:mb-0 md:w-2/5">
                  <div class="text-center text-lg bold font-bold">Quero criar uma conta</div>
                  <form @submit.prevent="signup">
                    <vs-input
                      v-validate="'required|email|min:3'"
                      data-vv-validate-on="blur"
                      name="emailNewAccount"
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="E-mail"
                      v-model.trim="emailNewAccount"
                      autocomplete="username"
                      class="w-full no-icon-border"
                    />

                    <vs-input
                      data-vv-validate-on="blur"
                      data-vv-as="Senha"
                      v-validate="'required|min:6|max:30'"
                      type="password"
                      name="passwordNewAccount"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Senha"
                      v-model="passwordNewAccount"
                      autocomplete="new-password"
                      class="w-full no-icon-border mt-6"
                    />

                    <vs-input
                      data-vv-validate-on="blur"
                      data-vv-as="Confirmação da Senha"
                      v-validate="'required|confirmed:passwordNewAccount|min:6|max:30'"
                      type="password"
                      name="passwordConfirmationNewAccount"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Confirmação da Senha"
                      v-model="passwordConfirmationNewAccount"
                      autocomplete="new-password"
                      class="w-full no-icon-border mt-6"
                    />

                    <span
                      class="text-danger text-sm"
                      v-show="
                        passwordConfirmationNewAccount.length &&
                          passwordNewAccount.length &&
                          passwordConfirmationNewAccount !== passwordNewAccount
                      "
                      >A senha e a confirmação da senha devem ser iguais.</span
                    >
                    <div class="flex flex-wrap my-5">
                      <vs-checkbox v-model="termsConfirmation" class="mb-3">Confirmo ter lido e aceito os</vs-checkbox>
                      <a
                        href="https://www.wtsoftware.com.br/suporte/termos-uso.html"
                        style="margin-right: 5px;"
                        target="_blank"
                        >Termos de Uso</a
                      >
                      |
                      <a
                        href="https://www.wtsoftware.com.br/suporte/politica-privacidade.html"
                        style="margin-left: 5px;"
                        target="_blank"
                      >
                        Política de Privacidade</a
                      >
                    </div>

                    <vs-button
                      type="relief"
                      button="button"
                      class="w-full mt-6"
                      @click.prevent="signup()"
                      :disabled="
                        basket.processing || !termsConfirmation || passwordConfirmationNewAccount !== passwordNewAccount
                      "
                    >
                      Continuar
                    </vs-button>
                  </form>
                </div>
                <div class="vx-col hidden md:w-1/5 md:flex justify-center">
                  <div class="bg-grey t w-px h-full">&nbsp;</div>
                </div>
                <div class="vx-col mt-8 md:mt-0 md:w-2/5">
                  <div class="text-center text-lg bold font-bold">Já sou cliente</div>

                  <vs-button type="relief" class="w-full mt-6" @click="login()" :disabled="basket.processing"
                    >Ir para a Página de Login</vs-button
                  >
                </div>
              </div>
              <div v-else class="flex flex-col md:flex-row p-4 md:p-0">
                <div class="vx-col mb-8 md:mb-0 w-full">
                  <div class="text-center text-lg bold font-bold">Você já está logado como {{ basket.email }}</div>

                  <div class="flex flex-col md:flex-row p-4 md:p-0">
                    <div class="md:w-2/5">
                      <vs-button
                        type="relief"
                        color="danger"
                        class="w-full mt-6"
                        @click="logout()"
                        :disabled="basket.processing"
                      >
                        Sair da Conta
                      </vs-button>
                    </div>
                    <div class="md:w-1/5">&nbsp;</div>
                    <div class="md:w-2/5">
                      <vs-button type="relief" class="w-full mt-6" @click="nextTab()" :disabled="basket.processing">
                        Continuar
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </tab-content>

      <tab-content title="Plano" icon="feather icon-shopping-bag" class="mb-5">
        <div class="checkout-plans-heading mb-4">
          <h3 class="checkout-plans-heading__title">
            {{ isNetspyCheckout ? 'Escolha seu plano NetSpy' : 'Escolha seu plano' }}
          </h3>
          <p class="checkout-plans-heading__sub">
            {{
              isNetspyCloudCheckout
                ? 'Selecione o plano NetSpy Cloud e continue para o pagamento.'
                : isNetspyCheckout
                  ? 'Selecione o plano para o software NetSpy Pro e continue para o pagamento.'
                  : 'Selecione a opção ideal e continue para o pagamento.'
            }}
          </p>
        </div>

        <div class="vx-row checkout-plan-layout" v-if="plans.length">
          <div class="vx-col w-full">
            <vx-card v-if="basket.plans.length" class="checkout-surface mb-4">
              <div class="checkout-section-heading">
                <h4 class="checkout-section-heading__title">Seu carrinho</h4>
                <p class="checkout-section-heading__sub">
                  Ajuste a quantidade ou remova itens antes de continuar.
                </p>
              </div>
              <CheckoutCartItems
                :plans="basket.plans"
                :currency-code="basket.currency_code"
                :processing="basket.processing"
                :allow-quantity="allowCartQuantity"
                @remove="removePlan"
                @quantity-change="setPlanQuantity"
              />
              <div class="flex justify-end mt-4">
                <vs-button type="relief" @click="goToPayment()" :disabled="basket.processing">
                  Ir para pagamento
                </vs-button>
              </div>
            </vx-card>

            <vx-card
              v-if="!isNetspyCheckout && !basket.device_has_subscription && basket.has_subscription"
              class="bg-danger text-white mb-4 p-6"
            >
              <strong>Atenção:</strong> Você já possui 1 ou mais planos VIP ativos. Não compre novamente o plano VIP
              para o mesmo dispositivo.
              <router-link to="/subscriptions" class="text-white underline">Ver planos VIP ativos.</router-link>
            </vx-card>

            <vx-card v-if="!isNetspyCheckout && basket.device_has_subscription" class="bg-danger text-white mb-4 p-6">
              <strong>Atenção:</strong> Este dispositivo já possui o plano VIP ativo. Cancele o plano existente antes
              de assinar um novo.
              <router-link to="/subscriptions" class="text-white underline">Ver planos VIP ativos.</router-link>
            </vx-card>

            <div
              class="items-list-view cursor-pointer"
              v-for="item in plans"
              :key="item.id"
              @click="changePlanSelected(item.id)"
            >
              <item-list-view
                :item="item"
                class="mb-4 checkout-plan-card"
                :class="{ 'checkout-plan-card--selected': String(planSelected) === String(item.id) }"
              >
                <template v-if="String(item.id) === String(planSelected)" slot="plan-selected">
                  <div class="plan-features">
                    <div class="plan-features__content">
                      <ul class="plan-features__list" v-if="!item.name.includes('Vip') || isNetspyCheckout">
                        <li v-for="feature in displayPlanFeaturesStandard" :key="feature.label">
                          <img :src="feature.icon" alt="" />
                          <span>{{ feature.label }}</span>
                        </li>
                      </ul>
                      <ul class="plan-features__list" v-else>
                        <li v-for="feature in planFeaturesVip" :key="feature.label">
                          <img :src="feature.icon" alt="" />
                          <span>{{ feature.label }}</span>
                        </li>
                      </ul>

                      <div v-if="!item.name.includes('Vip') || isNetspyCheckout" class="plan-features__more">
                        <button type="button" class="btn-expand" @click.stop="toggleExpand">
                          {{ isExpanded ? 'Esconder recursos extras' : 'Mostrar mais recursos' }}
                          <img
                            src="@/assets/images/checkout/chevron-down.svg"
                            alt=""
                            :class="{ rotated: isExpanded }"
                          />
                        </button>
                        <ul class="plan-features__list" v-if="isExpanded">
                          <li v-for="(funcao, index) in displayFuncoesAdicionais" :key="index">
                            <img src="@/assets/images/checkout/check-circle.svg" alt="" />
                            <span>{{ funcao }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div
                      v-if="allowCartQuantity && !item.recurring"
                      class="plan-features__quantity"
                      @click.stop
                    >
                      <span class="plan-features__quantity-label">Quantidade de licenças</span>
                      <div class="plan-features__quantity-controls">
                        <button
                          type="button"
                          class="plan-features__quantity-btn"
                          :disabled="basket.processing || selectedQuantity <= 1"
                          @click="selectedQuantity = Math.max(1, selectedQuantity - 1)"
                        >
                          −
                        </button>
                        <input
                          v-model.number="selectedQuantity"
                          type="number"
                          min="1"
                          max="20"
                          class="plan-features__quantity-input"
                          :disabled="basket.processing"
                        />
                        <button
                          type="button"
                          class="plan-features__quantity-btn"
                          :disabled="basket.processing || selectedQuantity >= 20"
                          @click="selectedQuantity = Math.min(20, selectedQuantity + 1)"
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <vs-button
                      type="relief"
                      class="plan-features__cta"
                      @click.stop="continueCheckoutPlan()"
                      :disabled="basket.processing"
                    >
                      {{ basket.plans.some(p => p.id === item.id) ? 'Continuar para pagamento' : 'Usar este plano' }}
                    </vs-button>
                  </div>
                </template>
              </item-list-view>
            </div>
          </div>
        </div>
      </tab-content>

      <tab-content title="Pagamento" icon="feather icon-credit-card" class="mb-5">
        <div
          v-if="isPaymentTabActive"
          class="vx-row checkout-payment-layout"
          :class="{ 'checkout-payment-layout--embedded-paypal': isEmbeddedPayPalCheckout }"
        >
          <div
            class="vx-col w-full"
            :class="isEmbeddedPayPalCheckout ? 'lg:w-full' : 'lg:w-2/3'"
          >
            <vx-card class="checkout-surface mb-6" v-show="!paymentMethod">
              <div class="checkout-section-heading">
                <h4 class="checkout-section-heading__title">Forma de pagamento</h4>
                <p class="checkout-section-heading__sub">Escolha como prefere pagar</p>
              </div>
              <PaymentTypeSelect
                v-if="!paymentMethod && basket.plans.length"
                :basket="basket"
                :paymentMethod="paymentMethod"
                :isSubscription="checkoutIsSubscription"
                @select-payment="onPaymentMethodSelected"
              />
              <p v-else-if="!paymentMethod" class="checkout-payment-missing">
                Selecione um plano para continuar.
              </p>
            </vx-card>

            <div v-if="paymentMethod && isCardGatewayActive && hasMultiplePaymentTypes" class="checkout-change-payment mb-4">
              <button type="button" class="checkout-change-payment__btn" @click="resetPaymentMethod">
                ← Alterar forma de pagamento
              </button>
            </div>

            <vx-card class="checkout-surface mb-base checkout-surface--form" v-if="paymentMethod">
              <div class="checkout-section-heading">
                <h4 class="checkout-section-heading__title">Dados do pagamento</h4>
                <p class="checkout-section-heading__sub">Só o essencial para concluir</p>
              </div>

              <component
                v-if="showGatewayForm && activeGatewayLoader"
                :is="activeGatewayLoader"
                :key="paymentMethod"
                :basket="basket"
                :paymentMethod="paymentMethod"
                :checkoutWizard="$refs.checkoutWizard"
                :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
              />

              <p v-else-if="paymentMethod && showGatewayForm && !activeGatewayLoader" class="checkout-payment-missing">
                Forma de pagamento indisponível no momento. Clique em "Alterar forma de pagamento" e tente novamente.
              </p>
              <p v-else-if="paymentMethod && !showGatewayForm" class="checkout-payment-missing">
                Carregando formulário…
              </p>
            </vx-card>

            <div class="mb-8">
              <vs-button
                type="relief"
                color="danger"
                @click="prevCheckoutTab()"
                :disabled="basket.processing"
              >
                Voltar
              </vs-button>
            </div>
          </div>

          <div class="vx-col lg:w-1/3 w-full" v-show="!isEmbeddedPayPalCheckout">
            <vx-card title="Detalhes da Compra" class="checkout-summary sticky">
              <div v-show="showCoupon && !numberOfSubscriptionProducts" class="mb-4">
                <vs-input
                  name="coupon"
                  label-placeholder="Código do Cupom"
                  v-model.trim="basket.coupon.code"
                  autocomplete="off"
                  class="w-full no-icon-border"
                />
                <vs-button class="mt-3 w-full" @click="applyCoupon()" type="relief" :disabled="basket.processing">
                  Aplicar Cupom
                </vs-button>
              </div>
              <div class="text-sm mb-3" v-show="!showCoupon && !numberOfSubscriptionProducts">
                <a href="javascript:;" @click="showCoupon = !showCoupon">Tenho um cupom</a>
              </div>

              <CheckoutCartItems
                v-if="basket.plans.length"
                class="mb-4"
                :plans="basket.plans"
                :currency-code="basket.currency_code"
                :processing="basket.processing"
                :allow-quantity="allowCartQuantity"
                @remove="removePlan"
                @quantity-change="setPlanQuantity"
              />

              <div class="flex justify-between mb-2" v-if="basket.discount > 0">
                <span>Subtotal</span>
                <span class="font-semibold">{{ basket.subtotal | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="basket.discount > 0">
                <span class="text-success">Desconto</span>
                <span class="font-semibold text-success">-{{ basket.discount | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Pagamento Único</span>
                <span class="font-semibold">{{ displayTotalToday | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="displayRecurringTotal > 0">
                <span>Pagamento Mensal</span>
                <span class="font-semibold text-success">{{
                  displayRecurringTotal | money(basket.currency_code)
                }}</span>
              </div>

              <vs-divider />
              <div class="flex justify-between">
                <span>Total Hoje</span>
                <span class="font-semibold">{{ displayTotalToday | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="displayRecurringTotal > 0">
                <span>Total Mensal</span>
                <span class="font-semibold text-success">{{
                  displayRecurringTotal | money(basket.currency_code)
                }}</span>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

const ItemListView = () => import('./components/ItemListView.vue');
const PaymentTypeSelect = () => import('./components/PaymentTypeSelect.vue');
const OrderDetails = () => import('./components/OrderDetails.vue');
const CheckoutCartItems = () => import('./components/CheckoutCartItems.vue');

import {
  getPaymentTypes,
  isEmbeddedPayPalCheckout as checkEmbeddedPayPalCheckout,
  isKnownPaymentMethod,
  resolvePaymentMethod
} from './utils/paymentProviderBalance';
import { isPlanRecurring, enrichPlan } from './utils/planRecurring';
import { getGatewayLoader } from './utils/gatewayRegistry';
import { checkoutLog, checkoutSnapshot, checkoutTabName, isCheckoutDebugEnabled } from './utils/checkoutDebug';
import {
  PRODUCT_MOBILE,
  PRODUCT_NETSPY_CLOUD,
  isNetspyProduct,
  filterPlansByProduct,
  inferProductIdFromPlan
} from './utils/checkoutProducts';

const CARD_GATEWAY_IDS = [
  'card',
  'card-iugu',
  'card-galaxpay',
  'card-pagarme',
  'card-pagseguro',
  'card-stripe',
  'card-mercadopago',
  'iugu-subscription',
  'paypal-subscription',
  'galaxpay-subscription',
  'pagarme-subscription',
  'pagseguro-subscription',
  'stripe-subscription'
];

export default {
  components: {
    OrderDetails,
    ItemListView,
    FormWizard,
    TabContent,
    PaymentTypeSelect,
    CheckoutCartItems
  },
  data() {
    return {
      appFilename: process.env.VUE_APP_FILENAME,
      emailNewAccount: '',
      emailLogin: '',
      passwordNewAccount: '',
      termsConfirmation: false,
      passwordConfirmationNewAccount: '',
      password: '',
      affiliate: '',

      plans: [],
      planSelected: '',
      selectedQuantity: 1,
      productId: null,
      planId: null,
      ip: null,
      card: '',

      isExpanded: false,
      funcoesAdicionais: ['Teclas Digitadas', 'Sites/Pesquisas', 'Foto Remota', 'Contatos'],
      planFeaturesStandard: [
        { label: 'WhatsApp', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Chamadas', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Escuta Ambiente', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Localização', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Instagram', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Fotos da Galeria', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'SMS', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Modo invisível', icon: require('@/assets/images/checkout/eye-off.svg') }
      ],
      planFeaturesVip: [
        { label: 'Todas as funções premium +', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Zona Segura', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Telegram', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Chamadas do WhatsApp', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Aplicativos Instalados', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Modo invisível', icon: require('@/assets/images/checkout/eye-off.svg') }
      ],
      planFeaturesDesktop: [
        { label: 'Teclas Digitadas', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Sites e Pesquisas', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Capturas de Tela', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Histórico Web', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Chat Monitorado', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Modo invisível', icon: require('@/assets/images/checkout/eye-off.svg') }
      ],
      planFeaturesCloud: [
        { label: 'Painel web na nuvem', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Monitoramento remoto', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Histórico de atividades', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Capturas de tela', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Acesso multi-dispositivo', icon: require('@/assets/images/checkout/check-circle.svg') },
        { label: 'Licença digital', icon: require('@/assets/images/checkout/check-circle.svg') }
      ],
      funcoesAdicionaisDesktop: [
        'Aplicativos utilizados',
        'Arquivos acessados',
        'Impressões',
        'Programas instalados'
      ],

      orderDetails: {
        order: {},
        pix: {}
      },
      orderId: null,
      orderNumber: null,

      orderDetailsChecking: false,

      showCoupon: false,

      checkoutStep: 0,
      wizardTabIndex: 0,
      showGatewayForm: false,

      paymentMethod: '',
      basket: {
        firstname: '',
        lastname: '',
        name: '',
        email: '',
        telephone_country_code: '',
        telephone: '',
        coupon: {
          amount: 0
        },
        cpfcnpj: '',
        processing: false,
        plans: [],
        has_subscription: false,
        device_has_subscription: false,
        address_street: '',
        address_number: '',
        address_complement: '',
        address_city: '',
        address_state: '',
        address_postcode: '',
        address_country: 'br',
        subtotal: 0,
        subtotalRecurring: 0,
        discount: 0,
        total: 0,
        device: null,
        key: null,
        currency_code: 'BRL',
        locale: 'pt-BR'
      }
    };
  },
  mounted() {
    if (isCheckoutDebugEnabled(this.$route)) {
      checkoutLog('init:mounted', checkoutSnapshot(this), this.$route);
      console.info('[checkout] Digite __checkoutDebug no console para ver o último status se a página travar.');
    }

    if (this.$route.query.aff) {
      localStorage.setItem('aff', this.$route.query.aff);
    }

    let language = window.navigator.userLanguage || window.navigator.language;
    if (language.indexOf('-') > -1) {
      language = language.split('-')[0];
    }

    this.$i18n.locale = 'pt';
    switch (language) {
      case 'pt':
      case 'en':
        this.$i18n.locale = language;
        break;
    }

    this.basket.locale = 'pt-BR';
    switch (language) {
      case 'en':
        this.basket.locale = 'en-GB';
        break;
    }

    this.basket.processing = false;

    this.planId = this.getParameterByName('planId');
    this.productId = this.getParameterByName('productId');
    this.orderId = this.getParameterByName('orderId');
    this.orderNumber = this.getParameterByName('orderNumber');
    this.ip = this.getParameterByName('ip');
    this.card = this.getParameterByName('card');

    this.basket.device = this.getParameterByName('d') ? atob(this.getParameterByName('d')) : null;
    this.basket.key = this.getParameterByName('k');

    if (isNetspyProduct(this.productId)) {
      this.basket.key = null;
      this.basket.device = null;
    }

    const token = this.$localStorage.get('token');
    checkoutLog(
      'init:route',
      {
        planId: this.planId,
        productId: this.productId,
        hasToken: !!token,
        card: this.card,
        orderId: this.orderId
      },
      this.$route
    );

    if (token && !this.planId && !this.productId && !this.orderId && !this.orderNumber && !this.card) {
      checkoutLog('init:flow', { branch: 'token-without-plan' }, this.$route);
      this.basket.processing = true;
      this.fetchPlans().then(() => {
        this.checkTokenWitouthPlanId();
      });
    } else if (token && !this.planId && this.productId && !this.orderId && !this.orderNumber && !this.card) {
      checkoutLog('init:flow', { branch: 'token-with-productId' }, this.$route);
      this.basket.processing = true;
      this.fetchPlans().then(() => {
        this.checkTokenWitouthPlanId();
      });
    } else if (token && this.planId && !this.productId && !this.orderId && !this.orderNumber && !this.card) {
      checkoutLog('init:flow', { branch: 'token-with-planId', planId: this.planId }, this.$route);
      this.basket.processing = true;
      this.fetchPlans().then(() => {
        this.checkToken2();
      });
    } else if (token && this.planId && this.productId && !this.orderId && !this.orderNumber && !this.card) {
      checkoutLog('init:flow', { branch: 'token-with-planId-and-productId' }, this.$route);
      this.basket.processing = true;
      this.fetchPlans().then(() => {
        this.checkToken();
        this.nextTab();
      });
    } else if (token && this.orderId && this.orderNumber) {
      checkoutLog('init:flow', { branch: 'load-order' }, this.$route);
      this.basket.processing = true;
      this.loadOrder();
    } else if (token && this.card && this.planId) {
      checkoutLog('init:flow', { branch: 'token-with-card-deep-link', card: this.card }, this.$route);
      this.basket.processing = true;
      this.fetchPlans().then(() => {
        this.checkToken3();
      });
    } else if (window.location.href.indexOf('/complete') > -1) {
      checkoutLog('init:flow', { branch: 'complete-page' }, this.$route);
      this.basket.processing = true;
      this.loadOrder();
    } else {
      checkoutLog('init:flow', { branch: 'guest-no-token' }, this.$route);
      this.basket.processing = false;
      if (this.planId || this.productId) {
        this.fetchPlans().then(() => {
          this.syncPlanFromUrl();
        });
      }
    }

    this.$EventBus.$on('changePaymentMethod', paymentMethod => {
      checkoutLog('payment:change-via-eventbus', { paymentMethod }, this.$route);
      this.onPaymentMethodSelected(paymentMethod);
    });

    this.$nextTick(() => {
      this.syncCheckoutStepFromWizard();
      checkoutLog('init:wizard-synced', checkoutSnapshot(this), this.$route);
    });
  },
  beforeDestroy() {
    clearInterval(this.orderDetailsChecking);
  },
  computed: {
    checkoutProductId() {
      return this.productId || PRODUCT_MOBILE;
    },
    isNetspyCheckout() {
      return isNetspyProduct(this.checkoutProductId);
    },
    isNetspyCloudCheckout() {
      return String(this.checkoutProductId) === String(PRODUCT_NETSPY_CLOUD);
    },
    displayPlanFeaturesStandard() {
      if (this.isNetspyCloudCheckout) {
        return this.planFeaturesCloud;
      }
      if (this.isNetspyCheckout) {
        return this.planFeaturesDesktop;
      }
      return this.planFeaturesStandard;
    },
    displayFuncoesAdicionais() {
      if (this.isNetspyCheckout) {
        return this.funcoesAdicionaisDesktop;
      }
      return this.funcoesAdicionais;
    },
    allowCartQuantity() {
      if (this.basket.key) {
        return false;
      }
      if (this.checkoutIsSubscription) {
        return false;
      }
      return true;
    },
    isPaymentTabActive() {
      return this.wizardTabIndex === 2;
    },
    activeGatewayLoader() {
      if (!this.paymentMethod || !this.showGatewayForm) {
        return null;
      }
      if (this.paymentMethod === 'card' && this.checkoutIsSubscription) {
        return null;
      }
      return getGatewayLoader(this.paymentMethod);
    },
    resolvedBasketPlans() {
      return (this.basket.plans || []).map(plan => enrichPlan(plan, this.plans));
    },
    numberOfNonSubscriptionProducts: function() {
      return this.resolvedBasketPlans.filter(plan => !isPlanRecurring(plan)).length;
    },
    numberOfSubscriptionProducts: function() {
      return this.resolvedBasketPlans.filter(plan => isPlanRecurring(plan)).length;
    },
    checkoutIsSubscription() {
      if (this.numberOfSubscriptionProducts > 0) {
        return true;
      }
      if (this.numberOfNonSubscriptionProducts > 0) {
        return false;
      }
      if (this.resolvedBasketPlans.some(plan => isPlanRecurring(plan))) {
        return true;
      }
      if (this.planId && this.plans && this.plans.length) {
        const selected = this.plans.find(plan => String(plan.id) === String(this.planId));
        if (selected) {
          return isPlanRecurring(selected);
        }
      }
      return false;
    },
    displayTotalToday() {
      const total = parseFloat(this.basket.total);
      if (!isNaN(total) && total > 0) {
        return total;
      }
      return this.computeTotalsFromPlans().total;
    },
    displayRecurringTotal() {
      const recurring = parseFloat(this.basket.subtotalRecurring);
      if (!isNaN(recurring) && recurring > 0) {
        return recurring;
      }
      return this.computeTotalsFromPlans().subtotalRecurring;
    },
    isEmbeddedPayPalCheckout() {
      return checkEmbeddedPayPalCheckout(this.paymentMethod);
    },
    isCardGatewayActive() {
      return CARD_GATEWAY_IDS.indexOf(this.paymentMethod) !== -1;
    },
    hasMultiplePaymentTypes() {
      return (
        getPaymentTypes({
          currency: this.basket.currency_code,
          isSubscription: this.checkoutIsSubscription
        }).length > 1
      );
    }
  },
  watch: {
    wizardTabIndex(value) {
      checkoutLog(
        'wizard:tab-index',
        { tab: checkoutTabName(value), index: value, ...checkoutSnapshot(this) },
        this.$route
      );
    },
    paymentMethod(value, oldValue) {
      checkoutLog('payment:method-changed', { from: oldValue, to: value, ...checkoutSnapshot(this) }, this.$route);
    },
    showGatewayForm(value) {
      checkoutLog(
        'payment:show-gateway-form',
        {
          showGatewayForm: value,
          paymentMethod: this.paymentMethod,
          hasGatewayLoader: !!this.activeGatewayLoader,
          ...checkoutSnapshot(this)
        },
        this.$route
      );
    },
    plans() {
      this.syncPlanFromUrl();
    },
    'basket.processing': function(value) {
      checkoutLog('basket:processing', { processing: value, ...checkoutSnapshot(this) }, this.$route);
      if (value) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    fetchPlans() {
      return this.$api
        .get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : ''))
        .then(response => {
          this.processPlansResponse(response.data.data || []);
          return this.loadBasketFromServer();
        });
    },
    processPlansResponse(allPlans) {
      this.ensureProductId(allPlans);
      this.applyNetspyCheckoutContext();
      const filtered = filterPlansByProduct(allPlans, this.checkoutProductId);
      this.plans = this.sortPlansVipFirst(filtered.slice().reverse());
    },
    ensureProductId(allPlans) {
      if (this.productId) {
        return;
      }

      const inferred = inferProductIdFromPlan(allPlans, this.planId);
      if (inferred) {
        this.productId = inferred;
      }
    },
    applyNetspyCheckoutContext() {
      if (!isNetspyProduct(this.checkoutProductId)) {
        return;
      }

      this.basket.key = null;
      this.basket.device = null;
    },
    resetPaymentMethod() {
      checkoutLog('payment:reset', checkoutSnapshot(this), this.$route);
      this.showGatewayForm = false;
      this.paymentMethod = '';
      this.$EventBus.$emit('resetPaymentType');
    },
    isVipPlan(plan) {
      return !!(plan && plan.name && String(plan.name).toLowerCase().includes('vip'));
    },
    sortPlansVipFirst(plans) {
      return (plans || []).slice().sort((a, b) => {
        const aVip = this.isVipPlan(a) ? 0 : 1;
        const bVip = this.isVipPlan(b) ? 0 : 1;
        return aVip - bVip;
      });
    },
    planSummaryPrice(plan) {
      const quantity = parseInt(plan.quantity, 10) > 0 ? parseInt(plan.quantity, 10) : 1;
      const setup = parseFloat(plan.setup_fee) || 0;
      const fixed = parseFloat(plan.fixed_price) || 0;
      const unit = setup > 0 ? setup : fixed;
      return unit * quantity;
    },
    computeTotalsFromPlans() {
      let subtotal = 0;
      let subtotalRecurring = 0;
      (this.basket.plans || []).forEach(plan => {
        const quantity = parseInt(plan.quantity, 10) > 0 ? parseInt(plan.quantity, 10) : 1;
        const setup = parseFloat(plan.setup_fee) || 0;
        const fixed = parseFloat(plan.fixed_price) || 0;
        if (setup > 0) {
          subtotal += setup * quantity;
          if (fixed > 0) {
            subtotalRecurring += fixed * quantity;
          }
        } else {
          subtotal += fixed * quantity;
        }
      });
      const discount = parseFloat(this.basket.discount) || 0;
      return {
        subtotal,
        subtotalRecurring,
        total: Math.max(0, subtotal - discount)
      };
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded; // Alterna a visibilidade
    },

    signup() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/auth/register', {
          email: this.emailNewAccount,
          password: this.passwordNewAccount,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          this.$vs.notify({
            time: 6000,
            text: 'Sua conta foi criada com sucesso.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          });

          this.basket.firstname = response.data.firstname;
          this.basket.lastname = response.data.lastname;
          this.basket.name = response.data.name;
          this.basket.email = response.data.email;
          this.basket.cpfcnpj = response.data.cpfcnpj;
          this.basket.address_street = response.data.address_street;
          this.basket.address_number = response.data.address_number;
          this.basket.address_complement = response.data.address_complement;
          this.basket.address_city = response.data.address_city;
          this.basket.address_state = response.data.address_state;
          this.basket.address_postcode = response.data.address_postcode;
          this.basket.address_country = response.data.address_country || 'br';
          this.basket.telephone_country_code = response.data.telephone_country_code || 55;
          this.basket.telephone = response.data.telephone;

          // this.addPlan(this.planId);

          this.$localStorage.set('token', response.data.access_token);
          this.$localStorage.set('user', JSON.stringify(response.data));
          // this.$EventBus.$emit('userChanged');

          this.$api
            .get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : ''))
            .then(response => {
              this.processPlansResponse(response.data.data || []);
            });

          if (this.planId) {
            this.checkToken2();
          } else {
            this.checkTokenWitouthPlanId();
          }
        })
        .catch(error => {
          this.basket.processing = false;

          const data = error.response && error.response.data ? error.response.data : {};
          const message = Array.isArray(data.errors)
            ? data.errors.join('<br>')
            : data.error || data.message || 'Não foi possível criar a conta. Tente novamente.';

          this.$vs.notify({
            time: 6000,
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },

    redirectPlan() {
      window.location.href = 'https://lite-beta.vercel.app/';
    },

    continueCheckoutPlan() {
      checkoutLog('plan:continue-selected', { planSelected: this.planSelected, selectedQuantity: this.selectedQuantity }, this.$route);
      this.planId = this.planSelected;
      this.addPlan(this.planId).then(() => {
        if (!this.basket.plans || !this.basket.plans.length) {
          return;
        }

        const quantity = Math.min(20, Math.max(1, parseInt(this.selectedQuantity, 10) || 1));
        const inCart = this.basket.plans.find(plan => String(plan.id) === String(this.planId));

        if (inCart && this.allowCartQuantity && quantity > 1) {
          return this.setPlanQuantity(inCart, quantity).then(() => {
            this.goToPayment();
          });
        }

        this.goToPayment();
      });
    },

    goToPlanTab() {
      while (this.wizardTabIndex > 1 && this.$refs.checkoutWizard) {
        this.prevCheckoutTab();
      }
    },
    goToPayment() {
      checkoutLog('wizard:go-to-payment', checkoutSnapshot(this), this.$route);
      // addPlan já atualizou os totais; não recalcular via lastStep
      // (evita zerar o total se o cache do carrinho estiver vazio nesta request)
      this.nextTab();
    },

    onCheckoutStepChange(prevIndex, nextIndex) {
      const step = typeof nextIndex === 'number' ? nextIndex : prevIndex;
      checkoutLog(
        'wizard:step-change',
        {
          from: checkoutTabName(prevIndex),
          to: checkoutTabName(step),
          prevIndex,
          nextIndex: step
        },
        this.$route
      );
      this.wizardTabIndex = step;
      this.checkoutStep = step;

      if (this.checkoutStep < 2 && this.paymentMethod) {
        this.resetPaymentMethod();
      }
    },

    syncCheckoutStepFromWizard() {
      const wizard = this.$refs.checkoutWizard;
      if (wizard && typeof wizard.activeTabIndex === 'number') {
        checkoutLog(
          'wizard:sync',
          { activeTabIndex: wizard.activeTabIndex, tab: checkoutTabName(wizard.activeTabIndex) },
          this.$route
        );
        this.wizardTabIndex = wizard.activeTabIndex;
        this.checkoutStep = wizard.activeTabIndex;
      }
    },

    onPaymentMethodSelected(paymentMethod) {
      checkoutLog('payment:select-start', { paymentMethod, ...checkoutSnapshot(this) }, this.$route);
      this.showGatewayForm = false;

      if (!paymentMethod) {
        checkoutLog('payment:select-cleared', {}, this.$route);
        this.paymentMethod = '';
        return;
      }

      let method = paymentMethod;
      const isSubscription = this.checkoutIsSubscription;
      if (isSubscription && (method === 'card' || method === 'card-iugu')) {
        method =
          resolvePaymentMethod('card', {
            isSubscription: true,
            currency: this.basket.currency_code
          }) || method;
        checkoutLog('payment:subscription-reroute', { from: paymentMethod, to: method }, this.$route);
      }

      checkoutLog(
        'payment:select-resolved',
        {
          method,
          isSubscription,
          wizardTabIndex: this.wizardTabIndex,
          hasGatewayLoader: !!getGatewayLoader(method),
          plans: this.basket.plans
        },
        this.$route
      );

      this.paymentMethod = method;
      this.$nextTick(() => {
        checkoutLog('payment:mount-gateway-nextTick', checkoutSnapshot(this), this.$route);
        this.showGatewayForm = true;
      });
    },

    checkTokenWitouthPlanId() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          // this.addPlan(this.planId);

          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            this.nextTab();
            this.basket.processing = false;
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },

    checkToken() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          this.addPlan(this.planId);

          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            this.nextTab();
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },
    checkToken2() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            return this.addPlan(this.planId).then(() => {
              this.advanceAfterPlanInBasket();
            });
          }

          this.basket.processing = false;
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },
    checkToken3() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          this.addPlan(this.planId);

          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            this.nextTab();
            this.nextTab();
            if (this.card && isKnownPaymentMethod(this.card)) {
              this.$EventBus.$emit('changePaymentMethod', this.card);
            }
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },
    nextTab() {
      checkoutLog('wizard:next-tab', checkoutSnapshot(this), this.$route);
      if (this.$refs.checkoutWizard) {
        this.$refs.checkoutWizard.nextTab();
        this.$nextTick(() => {
          this.syncCheckoutStepFromWizard();
        });
      }
    },
    prevCheckoutTab() {
      if (this.$refs.checkoutWizard) {
        this.$refs.checkoutWizard.prevTab();
        this.$nextTick(() => {
          this.syncCheckoutStepFromWizard();
        });
      }
    },
    login() {
      const params = new URLSearchParams();
      if (this.planId) params.set('planId', this.planId);
      if (this.productId) params.set('productId', this.productId);
      const query = params.toString();
      this.$router.push('/pages/login?returnTo=/checkout/payment' + (query ? '?' + query : ''));
    },
    logout() {
      this.basket.processing = false;
      this.$localStorage.set('token', '');
      this.$localStorage.set('user', '');

      this.basket.firstname = '';
      this.basket.lastname = '';
      this.basket.name = '';
      this.basket.email = '';
      this.basket.cpfcnpj = '';
      this.basket.address_street = '';
      this.basket.address_number = '';
      this.basket.address_complement = '';
      this.basket.address_city = '';
      this.basket.address_state = '';
      this.basket.address_postcode = '';
      this.basket.address_country = 'br';
      this.basket.telephone_country_code = '';
      this.basket.telephone = '';
    },
    applyBasketResponse(response) {
      if (!response) {
        return;
      }

      if (response.plans) {
        this.basket.plans = response.plans;
      }
      this.basket.has_subscription = response.has_subscription;
      this.basket.device_has_subscription = response.device_has_subscription;
      this.basket.subtotal = response.subtotal;
      this.basket.subtotalRecurring = response.subtotalRecurring;
      this.basket.discount = response.discount;
      this.basket.total = response.total;
      if (response.currency_code) {
        this.basket.currency_code = response.currency_code;
      }
    },
    loadBasketFromServer() {
      const token = this.$localStorage.get('token');
      if (!token) {
        return Promise.resolve();
      }

      return this.$api
        .post('/api/v1/checkout/total?ip=' + this.ip, {
          basket: this.basket
        })
        .then(response => {
          this.applyBasketResponse(response.data);
        })
        .catch(() => {});
    },
    addPlan(planId) {
      checkoutLog('plan:add-start', { planId, ...checkoutSnapshot(this) }, this.$route);
      this.basket.processing = true;

      planId = parseInt(planId) > 0 ? planId : 0;
      const params = {};
      if (this.basket.key && !isNetspyProduct(this.checkoutProductId)) {
        params.k = this.basket.key;
      }

      return this.$api
        .get('/api/v1/checkout/plan/add/' + planId + '?ip=' + this.ip, {
          params
        })
        .then(response => {
          this.basket.processing = false;
          this.applyBasketResponse(response.data);

          checkoutLog(
            'plan:add-done',
            {
              planId,
              plans: response.data.plans,
              total: response.data.total,
              subtotalRecurring: response.data.subtotalRecurring,
              message: response.data.message || null,
              ...checkoutSnapshot(this)
            },
            this.$route
          );

          this.syncPlanFromUrl();

          if (!(parseFloat(this.basket.total) > 0) && this.basket.plans.length) {
            const computed = this.computeTotalsFromPlans();
            this.basket.subtotal = computed.subtotal;
            this.basket.subtotalRecurring = computed.subtotalRecurring;
            this.basket.total = computed.total;
          }

          if (response.data.total > 0) {
            this.$gtm.trackEvent({
              event: 'conversion',
              send_to: 'AW-604564883/slchCJbyz4YCEJPbo6AC',
              totalCarrinho: parseFloat(this.basket.total),
              currency: this.basket.currency_code,
              value: parseFloat(this.basket.total),
              transaction_id: ''
            });
          }

          if (response.data.message) {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          } else if (this.basket.plans.length === 0) {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: 'Não foi possível adicionar plano ao carrinho.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });

            this.$localStorage.set('token', '');
            this.$localStorage.set('user', '');
          }
        })
        .catch(error => {
          this.basket.processing = false;
          checkoutLog(
            'plan:add-error',
            {
              planId,
              error: (error.response && (error.response.data.error || error.response.data.message)) || error.message
            },
            this.$route
          );

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    removePlan(item) {
      this.basket.processing = true;

      this.$api
        .get('/api/v1/checkout/plan/' + item.id + '/remove')
        .then(response => {
          this.applyBasketResponse(response.data);

          if (this.basket.plans.length === 0) {
            this.planSelected = '';
            this.planId = null;
            this.selectedQuantity = 1;
            this.paymentMethod = '';
            this.showGatewayForm = false;
            this.basket.processing = false;

            if (this.wizardTabIndex > 1) {
              this.goToPlanTab();
            }
            return;
          }

          this.basket.processing = false;
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    applyCoupon() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/total?ip=' + this.ip, {
          basket: this.basket
        })
        .then(response => {
          this.basket.processing = false;

          if (response.data.plans) {
            this.basket.plans = response.data.plans;
          }
          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;

          if (!response.data.discount) {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: 'Cupom Inválido',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    loadOrder() {
      this.$api
        .get('/api/v1/checkout/order/' + (this.orderId || 0) + '/' + (this.orderNumber || 0) + '?ip=' + this.ip)
        .then(response => {
          this.basket.processing = false;
          this.orderDetails = response.data;
          this.orderId = response.data.order.id;
          this.orderNumber = response.data.order.number;

          this.$gtm.trackEvent({
            event: 'conversion',
            send_to: 'AW-604564883/ZHxjCLTYiOsBEJPbo6AC',
            numeroVenda: this.orderDetails.order.number,
            totalVenda: parseFloat(this.orderDetails.order.total),
            currency: this.basket.currency_code,
            value: parseFloat(this.orderDetails.order.total),
            transaction_id: this.orderDetails.order.number
          });

          if (response.data.order.status === 'Aguardando Pagamento') {
            clearInterval(this.orderDetailsChecking);
            this.orderDetailsChecking = setInterval(() => this.loadOrder(), 5000);
          } else {
            clearInterval(this.orderDetailsChecking);
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    setPlanQuantity(plan, quantity) {
      const nextQuantity = Math.min(20, Math.max(1, parseInt(quantity, 10) || 1));
      this.basket.processing = true;

      return this.$api
        .post(`/api/v1/checkout/plan/${plan.id}/quantity/${nextQuantity}` + '?ip=' + this.ip)
        .then(response => {
          this.basket.processing = false;
          this.applyBasketResponse(response.data);

          if (String(this.planSelected) === String(plan.id)) {
            this.selectedQuantity = nextQuantity;
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    updateItemQuantity(item) {
      return this.setPlanQuantity(item, item.quantity);
    },
    lastStep() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/total?ip=' + this.ip, {
          basket: this.basket
        })
        .then(response => {
          this.basket.processing = false;

          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;

          this.nextTab();
        });
    },
    changePlanSelected(plan) {
      this.planSelected = plan;
      const inCart = (this.basket.plans || []).find(item => String(item.id) === String(plan));
      this.selectedQuantity = inCart ? parseInt(inCart.quantity, 10) || 1 : 1;
    },
    syncPlanFromUrl() {
      const planId = parseInt(this.planId, 10);
      if (!(planId > 0) || !(this.plans && this.plans.length)) {
        return false;
      }

      const match = this.plans.find(plan => String(plan.id) === String(planId));
      if (!match) {
        return false;
      }

      this.planSelected = match.id;
      this.planId = String(match.id);
      checkoutLog('plan:sync-from-url', { planId: match.id, name: match.name }, this.$route);
      return true;
    },
    isCheckoutPaymentRoute() {
      return (
        (this.$route && this.$route.path === '/checkout/payment') ||
        window.location.pathname.indexOf('/checkout/payment') > -1
      );
    },
    advanceAfterPlanInBasket() {
      if (!this.basket.plans || !this.basket.plans.length) {
        return;
      }

      this.syncPlanFromUrl();
      this.nextTab();

      if (this.isCheckoutPaymentRoute()) {
        this.$nextTick(() => {
          this.syncPlanFromUrl();
          this.nextTab();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#ecommerce-checkout {
  --checkout-primary: #5c3498;
  --checkout-primary-soft: rgba(92, 52, 152, 0.1);
  --checkout-ink: #1f1630;
  --checkout-muted: #6f6780;
  --checkout-line: rgba(92, 52, 152, 0.12);
  --checkout-card: #ffffff;
  --checkout-radius: 16px;

  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding: 0.5rem 0 2rem;
  position: relative;

  &::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    pointer-events: none;
    background:
      radial-gradient(ellipse 80% 50% at 10% -10%, rgba(92, 52, 152, 0.14), transparent 55%),
      radial-gradient(ellipse 60% 40% at 100% 0%, rgba(113, 63, 188, 0.1), transparent 50%),
      linear-gradient(180deg, #f7f4fb 0%, #f3f0f8 40%, #faf9fc 100%);
  }

  .checkout-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin: 1rem 0 1.5rem;
    padding: 0.85rem 1.15rem;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid var(--checkout-line);
    box-shadow: 0 8px 28px rgba(49, 28, 84, 0.06);
    backdrop-filter: blur(10px);

    &__logo {
      display: block;
    }

    &__tagline {
      margin: 0;
      font-size: 0.8rem;
      font-weight: 600;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: var(--checkout-primary);
      opacity: 0.85;
    }
  }

  .checkout-surface {
    border-radius: var(--checkout-radius) !important;
    border: 1px solid var(--checkout-line);
    box-shadow: 0 10px 32px rgba(49, 28, 84, 0.06);
    overflow: hidden;
    transition: box-shadow 0.2s ease, transform 0.2s ease;

    &--form {
      animation: checkout-fade-up 0.28s ease;
    }
  }

  .checkout-section-heading {
    margin-bottom: 1.15rem;

    &__title {
      margin: 0 0 0.25rem;
      font-size: 1.15rem;
      font-weight: 700;
      color: var(--checkout-ink);
      letter-spacing: -0.01em;
    }

    &__sub {
      margin: 0;
      font-size: 0.9rem;
      color: var(--checkout-muted);
    }
  }

  .checkout-plans-heading {
    margin-bottom: 1.5rem !important;

    &__title {
      font-size: 1.5rem;
      font-weight: 750;
      color: var(--checkout-ink);
      margin-bottom: 0.35rem;
      letter-spacing: -0.02em;
    }

    &__sub {
      margin: 0;
      color: var(--checkout-muted);
      font-size: 0.98rem;
    }
  }

  .checkout-summary {
    border-radius: var(--checkout-radius);
    border: 1px solid var(--checkout-line);
    box-shadow: 0 12px 36px rgba(49, 28, 84, 0.08);
    overflow: hidden;
    background: linear-gradient(180deg, #fff 0%, #faf8fd 100%);

    &.sticky {
      position: sticky;
      top: 1rem;
    }

    &__inner {
      padding: 0.25rem 0.15rem;
    }

    &__title {
      font-size: 1.1rem;
      font-weight: 700;
      margin-bottom: 1rem;
      color: var(--checkout-ink);
    }

    &__plan {
      padding: 0.85rem 1rem;
      border-radius: 12px;
      background: var(--checkout-primary-soft);
      margin-bottom: 1rem;
    }

    &__plan-name {
      font-weight: 700;
      color: var(--checkout-ink);
    }

    &__device {
      display: block;
      margin-top: 0.35rem;
      color: var(--checkout-muted);
    }

    &__coupon {
      margin-bottom: 1rem;
    }

    &__totals {
      border-top: 1px solid var(--checkout-line);
      padding-top: 0.85rem;
      margin-bottom: 0.75rem;
    }

    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      color: #626262;

      &--total {
        margin-top: 0.35rem;
        margin-bottom: 0;
        font-size: 1.05rem;
        font-weight: 700;
        color: var(--checkout-ink);
      }
    }

    &__coupon-link {
      font-size: 0.875rem;
      margin-bottom: 1rem;

      a {
        color: var(--checkout-primary);
        font-weight: 600;
      }
    }

    &__actions {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      @media (min-width: 640px) {
        flex-direction: row;
      }
    }
  }

  .checkout-change-payment {
    &__btn {
      background: none;
      border: none;
      padding: 0;
      color: #5c3498;
      font-size: 0.88rem;
      font-weight: 600;
      cursor: pointer;
      text-decoration: underline;
      text-underline-offset: 2px;

      &:hover {
        color: #7348b0;
      }
    }
  }

  .checkout-payment-layout--embedded-paypal {
    .checkout-surface--form {
      max-width: 640px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .checkout-payment-missing {
    margin: 0;
    padding: 0.85rem 1rem;
    border-radius: 10px;
    background: rgba(255, 195, 6, 0.12);
    border: 1px solid rgba(255, 195, 6, 0.35);
    color: #5c4a12;
    font-size: 0.9rem;
    line-height: 1.45;
  }

  .checkout-plan-layout {
    align-items: flex-start;
  }

  .checkout-plan-card {
    border: 2px solid transparent !important;
    border-radius: var(--checkout-radius) !important;
    box-shadow: 0 6px 22px rgba(49, 28, 84, 0.05);
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 28px rgba(49, 28, 84, 0.1);
    }

    &--selected {
      border-color: var(--checkout-primary) !important;
      box-shadow: 0 0 0 1px rgba(92, 52, 152, 0.28), 0 14px 34px rgba(92, 52, 152, 0.16);

      ::v-deep .plan-card-radio {
        border-color: var(--checkout-primary);
        background: var(--checkout-primary-soft);

        .plan-card-radio__dot {
          background: var(--checkout-primary);
        }
      }
    }
  }

  .plan-features {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    @media (min-width: 1024px) {
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
    }

    &__content {
      flex: 1;
      min-width: 0;
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0 0 0.25rem;
      display: grid;
      grid-template-columns: 1fr;
      gap: 0.55rem;

      @media (min-width: 640px) {
        grid-template-columns: 1fr 1fr;
      }

      li {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9rem;
        font-weight: 600;
        color: #3a3a3a;
        line-height: 1.3;

        img {
          width: 15px;
          height: 15px;
          flex-shrink: 0;
        }
      }
    }

    &__more {
      margin-top: 0.25rem;
    }

    &__cta {
      width: 100%;
      flex-shrink: 0;

      @media (min-width: 1024px) {
        width: auto;
        min-width: 200px;
      }
    }

    &__quantity {
      margin-bottom: 1rem;
    }

    &__quantity-label {
      display: block;
      font-size: 0.85rem;
      font-weight: 600;
      color: #5c3498;
      margin-bottom: 0.45rem;
    }

    &__quantity-controls {
      display: inline-flex;
      align-items: center;
      border: 1px solid rgba(92, 52, 152, 0.18);
      border-radius: 10px;
      overflow: hidden;
      background: #fff;
    }

    &__quantity-btn {
      width: 36px;
      height: 38px;
      border: none;
      background: rgba(92, 52, 152, 0.08);
      color: #5c3498;
      font-size: 1rem;
      font-weight: 700;
      cursor: pointer;

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }

    &__quantity-input {
      width: 48px;
      height: 38px;
      border: none;
      border-left: 1px solid rgba(92, 52, 152, 0.12);
      border-right: 1px solid rgba(92, 52, 152, 0.12);
      text-align: center;
      font-weight: 600;
      color: #1f1630;
      -moz-appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  .btn-expand {
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: transparent;
    padding: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--checkout-primary);
    margin: 0.25rem 0 0.75rem;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .rotated {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  .vue-form-wizard.checkout-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
      margin-bottom: 0.5rem;
    }

    ::v-deep .wizard-navigation {
      margin-bottom: 1.75rem;
      padding: 1.1rem 1rem 1.25rem;
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.78);
      border: 1px solid var(--checkout-line);
      box-shadow: 0 10px 30px rgba(49, 28, 84, 0.07);
      backdrop-filter: blur(10px);

      .wizard-progress-with-circle {
        top: 38px !important;
        height: 3px !important;
        background: rgba(92, 52, 152, 0.12) !important;
      }

      .wizard-progress-bar {
        background: linear-gradient(90deg, #5c3498, #8b5fd4) !important;
        box-shadow: 0 0 12px rgba(92, 52, 152, 0.35);
      }

      .wizard-nav {
        .wizard-icon-circle {
          width: 52px;
          height: 52px;
          border-width: 2px !important;
          border-color: #d9d0e8 !important;
          background: #fff !important;
          box-shadow: 0 4px 14px rgba(49, 28, 84, 0.08);
          transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

          .wizard-icon {
            font-size: 1.25rem;
            color: #9a90ad;
            transition: color 0.2s ease;
          }
        }

        li.active,
        li.checked {
          .wizard-icon-circle {
            border-color: var(--checkout-primary) !important;
            background: linear-gradient(145deg, #5c3498, #7a4fc0) !important;
            box-shadow: 0 8px 20px rgba(92, 52, 152, 0.35);
            transform: translateY(-2px);

            .wizard-icon {
              color: #fff !important;
            }

            .wizard-icon-container {
              background: transparent !important;
            }
          }
        }

        li.checked:not(.active) .wizard-icon-circle {
          background: linear-gradient(145deg, #6b3fad, #5c3498) !important;
        }

        .stepTitle {
          margin-top: 0.65rem;
          font-size: 0.85rem;
          font-weight: 600;
          color: #9a90ad;
          letter-spacing: 0.01em;
          transition: color 0.2s ease;
        }

        li.active .stepTitle,
        li.checked .stepTitle {
          color: var(--checkout-primary);
          font-weight: 700;
        }
      }
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
        animation: checkout-fade-up 0.3s ease;
      }
    }
  }
}

@keyframes checkout-fade-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
